import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, ModalBody, ModalFooter, Spinner, Text, VStack } from '@bonusly/design-system';

import { EmployeeSpotlight } from '../../../schemas/spotlight';
import { SpotlightListItem } from './spotlight-list-item';

interface GeneratedSpotlightsListProps {
	spotlights: EmployeeSpotlight[];
	isLoading: boolean;
	targetUserName?: string;
	onCreateNew: () => void;
	onAddToRecognition?: (spotlight: EmployeeSpotlight) => void;
}

export const GeneratedSpotlightsList: FC<GeneratedSpotlightsListProps> = ({ spotlights, isLoading, targetUserName, onCreateNew, onAddToRecognition }) => {
	const { t } = useTranslation('spotlight');

	return (
		<>
			<ModalBody>
				{isLoading ? (
					<Box textAlign="center" py={8}>
						<Spinner size="md" />
					</Box>
				) : spotlights.length === 0 ? (
					<Box textAlign="center" py={8}>
						<Text color="text.soft">{t('generatedSpotlightsModal.empty')}</Text>
					</Box>
				) : (
					<VStack spacing={3} align="stretch" data-testid="generated-spotlights-list">
						{spotlights.map((spotlight) => (
							<SpotlightListItem key={spotlight.id} spotlight={spotlight} targetUserName={targetUserName} onAddToRecognition={onAddToRecognition} />
						))}
					</VStack>
				)}
			</ModalBody>
			<ModalFooter>
				<Button colorScheme="primary" onClick={onCreateNew} data-testid="create-spotlight-button">
					{t('generatedSpotlightsModal.createSpotlight')}
				</Button>
			</ModalFooter>
		</>
	);
};
